import React, { useState } from "react";
import TabDescription from "./TabDescription";
import { TabReview } from "./TabReview";
import { useParams } from "react-router-dom";

const TabArea = ({ tabData }) => {
  const productId = useParams();
  const [tabType, setTabType] = useState("description");
  return (
    <div className="col-12 wow fadeInUp mt-5" data-wow-duration="1s">
      <div
        className="d-flex align-items-center"
        style={{ borderBottom: "1px solid #cd2128" }}
      >
        <button
          className="py-2 px-4"
          style={{
            background: `${tabType === "description" ? "#cd2128" : "#fff"}`,
            color: `${tabType === "description" ? "#fff" : "#000"}`,
          }}
          onClick={() => setTabType("description")}
        >
          Description
        </button>

        <button
          className="py-2 px-4"
          style={{
            background: `${tabType === "review" ? "#cd2128" : "#fff"}`,
            color: `${tabType === "review" ? "#fff" : "#000"}`,
          }}
          onClick={() => setTabType("review")}
        >
          Reviews
        </button>
      </div>
      {tabType === "description" ? (
        <TabDescription tabDescription={tabData?.detail_description} />
      ) : tabType === "review" ? (
        <TabReview productId={productId} />
      ) : (
        "No data To show"
      )}
    </div>
  );
};
export default TabArea;
